import { ListCategoryDoc } from '../../redux-toolkits/categories/categories.type'
import { StorefrontSection } from '../../redux-toolkits/shared/shared.type'

const sectionLabels: Record<StorefrontSection, string> = {
  EVENT: 'Event',
  FOOD: 'Food',
  LIFESTYLE: 'Lifestyle',
}

const resolveSectionFromCategoryName = (categoryName?: string) => {
  const normalizedName = categoryName?.toLowerCase() ?? ''

  if (
    ['event', 'events', 'ticket', 'tickets', 'experience'].some((keyword) =>
      normalizedName.includes(keyword),
    )
  ) {
    return 'EVENT'
  }

  if (normalizedName.includes('food')) {
    return 'FOOD'
  }

  return 'LIFESTYLE'
}

export const getCategorySections = (
  categories: Pick<ListCategoryDoc, 'name' | 'section'>[] = [],
) => {
  return Array.from(
    new Set<StorefrontSection>(
      categories.length > 0
        ? categories.map(
            (category) =>
              category.section ?? resolveSectionFromCategoryName(category.name),
          )
        : ['LIFESTYLE'],
    ),
  )
}

export const CategorySectionSummary = ({
  categories = [],
  label = 'Section',
}: {
  categories?: Pick<ListCategoryDoc, 'name' | 'section'>[]
  label?: string
}) => {
  const sections = getCategorySections(categories)

  return (
    <p className="text-sm text-sec-black">
      {label}:{' '}
      <span className="font-medium text-black">
        {sections.map((section) => sectionLabels[section]).join(', ')}
      </span>
    </p>
  )
}
